import * as S from "components/common/Banner/Overlay.style";

const Overlay = () => (
  <S.Overlay>
    <S.TextBanner variant="headline-01" color="white">
      <S.MainInfo>CNP Seguros Holding Brasil - CSH</S.MainInfo>
      <S.SecondaryInfo>Há mais de 20 anos cuidando dos brasileiros.</S.SecondaryInfo>
    </S.TextBanner>
    <S.BannerIndicator />
  </S.Overlay>
);
export default Overlay;
